export enum RequestUpdateNotificationType {
	Email = 1,
	Sms = 3
}
